// extracted by mini-css-extract-plugin
export var closed = "_b3-1";
export var resizer = "_b3-0";